export function getView(advanced_editor) {
  return advanced_editor ? 'Advanced' : 'Simplified'
}
